
interface AvatarProps {
  name: string;
  /** 1-8; maps to --speaker-1 .. --speaker-8 CSS vars */
  hueIndex?: number;
  size?: number;
  className?: string;
}

/**
 * Extract up to two initials from a full name.
 * Works for both Latin and Hebrew (or any Unicode) names.
 *
 * "John Doe"    → "JD"
 * "Alice"       → "A"
 * "אילן הדס"    → "אה"  (first character of each word)
 */
function getInitials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "";
  if (words.length === 1) {
    // Return first char (handles multi-byte Unicode correctly via spread)
    return [...words[0]][0] ?? "";
  }
  // First char of first word + first char of second word
  return ([...words[0]][0] ?? "") + ([...words[1]][0] ?? "");
}

export function Avatar({ name, hueIndex, size = 28, className = "" }: AvatarProps) {
  const initials = getInitials(name);
  const hue = hueIndex !== undefined ? hueIndex : undefined;

  return (
    <span
      className={`avatar-kit ${className}`.trim()}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.41) }}
      data-hue={hue}
      title={name}
      aria-label={name}
    >
      {initials}
    </span>
  );
}
